import { useRef } from 'react'
import { useRequest, useReactive } from 'ahooks'

import { Table } from '@sar/component'
import { UploadImage } from 'components'

import { Spin } from 'antd'
import { ModalForm } from '@ant-design/pro-components'

enum modes {
  status,
  principal,
}

export default function ({ store, params, navigator }) {
  const state = useReactive<any>({
    open: false
  })

  const { data: order } = useRequest<any, any>(() => store.externals.api.get(`/orders/info/${params.id}`), {
    refreshDeps: [ params.id ]
  })

  let [
      processStatus
    , processStatusOptions
    , orderProductionStatus
    , orderProductionStatusOptions ] = React.useMemo(() => {
    return [
        store.config.getConstantEnums('ProductionProcessStatus')
      , store.config.getConstantValues('ProductionProcessStatus')
      , store.config.getConstantEnums('OrderProductionStatus')
      , store.config.getConstantValues('OrderProductionStatus')
    ]
  }, [])

  const res = useRequest<any, any>(() => {
    if (params.type == 3) {
      return Promise.all([
        store.externals.api.get(`/orders/production/${params.id}`, {
          params: {
            type: 1,
          }
        }),

        store.externals.api.get(`/orders/production/${params.id}`, {
          params: {
            type: 2,
          }
        }),
      ]).then((result) => {
        return result.map((data, index) => Object.assign(data, {
          orderType: index + 1,
        }))
      })
    }

    else {
      return Promise.all([
        store.externals.api.get(`/orders/production/${params.id}`, {
          params: {
            type: params.type,
          }
        }),
      ]).then((result) => {
        return result.map((data, index) => Object.assign(data, {
          orderType: params.type,
        }))
      })
    }
  })

  const handleSave = useRequest(
    async (data, status, mode: modes, type) => {
      if (mode == modes.status) {
        return store.externals.api.put(`/orders/production/status/${params.id}`, {
            type
          , status
          , value: data
        })
      }

      else {
        return store.externals.api.put(`/orders/production/name/${params.id}`, {
            type
          , status
          , name: data
        })
      }
    },
    {
      manual: true,
      debounceWait: 300,
    }
  )

  const handleUploadSave = useRequest(
    async (data, status) => {
      await store.externals.api.put(`/orders/production/file/${params.id}?type=${state.type}&status=${status}`, data.map(elm => {
        return {
          url: elm.url,
          fileName: elm.filename,
        }
      }))

      res.mutate(Object.assign(res.data, {
        [ `up${status.slice(0, 1).toUpperCase()}${status.slice(1)}` ]: true, [ `${status}UploadTime` ]: moment().format('YYYY-MM-DD'),
      }))
    },

    {
      manual: true,
    },
  )

  const handleUpload = file => store.oss.client.multipartUpload(`${store.externals.nonce()}.${file.name.split('.').pop()}`, file).then(
    res => `//${store.oss.endpoint}/${res.name}`
  )

  return <div className='m-4 p-4 bg-white'>
    <Spin spinning={res.loading} tip='加载中...'>
      <table className='w-full border-collapse border border-slate-300 my-4'>
        <tbody>
          <tr>
            <td className='border border-slate-300 text-right p-3 w-1/4 bg-gray-100'>订单编号</td>
            <td className='border border-slate-300 text-left p-3 w-1/4'>{order?.number}</td>
            <td className='border border-slate-300 text-right p-3 w-1/4 bg-gray-100'>设计师</td>
            <td className='border border-slate-300 text-left p-3 w-1/4'>{order?.designerName}</td>
          </tr>

          <tr>
            <td className='border border-slate-300 text-right p-3 w-1/4 bg-gray-100'>拆单员</td>
            <td className='border border-slate-300 text-left p-3 w-1/4'>{order?.splitterName}</td>
            <td className='border border-slate-300 text-right p-3 w-1/4 bg-gray-100'>生产跟踪员</td>
            <td className='border border-slate-300 text-left p-3 w-1/4'>{order?.producerName}</td>
          </tr>
        </tbody>
      </table>
    </Spin>

    <table className='w-full border-collapse border border-slate-300 mt-8'>
      <tbody>
        {res.data?.map((data, index) => {
          let fields = (
            [ '1', '7' ].includes(data.orderType)
              ? [
                  'cutting'
                , 'edgeBand'
                , 'drilling'
                , 'sorting'
                , 'qualityCheck'
                , 'cleaningPacking'
                , 'completionStorage'
              ] : [
                  'cutting'
                , 'milling'
                , 'polishing'
                , 'painting'
                , 'sorting'
                , 'qualityCheck'
                , 'cleaningPacking'
                , 'completionStorage'
              ]
          )

          return <>
            <tr>
              <td colSpan={9} className='border border-slate-300 text-left p-3 bg-gray-100 font-bold'>
                {
                  [ '1', '7' ].includes(data.orderType)
                    ? '板式进度列表'
                    : '原木进度列表'
                }
              </td>
            </tr>

            {fields.map((status, index) => {
              return <tr>
                <td className='border border-slate-300 text-center p-3 bg-gray-100 font-bold text-gray-500'>{R.inc(index)}</td>
                <td className='border border-slate-300 text-center p-3 bg-gray-100 font-bold text-gray-500'>{orderProductionStatus[status]}状态</td>
                <td className='border border-slate-300 text-center p-3'>{processStatus[data[`${status}Status`]]}</td>
                <td className='border border-slate-300 text-center p-3 font-bold text-gray-500'>负责人</td>
                <td className='border border-slate-300 text-center p-3'>{data[`${status}Emp`]}</td>
                <td className='border border-slate-300 text-center p-3 font-bold text-gray-500'>图片</td>
                <td className='border border-slate-300 text-center p-3'>
                  <a style={{ color: '#60a5fa' }} onClick={() => Object.assign(state, { open: true, status, type: data.orderType })}>预览</a>
                </td>
                <td className='border border-slate-300 text-center p-3 font-bold text-gray-500'>上传时间</td>
                <td className='border border-slate-300 text-center p-3'>{data[`${status}UploadTime`]}</td>
              </tr>
            })}
          </>
        })}
      </tbody>
    </table>

    <ModalForm
      width={600}
      open={state.open}
      modalProps={{ centered: true, destroyOnClose: true }}
      rowProps={{ gutter: 24 }}
      layout='vertical'
      request={async () => {
        const result = await store.externals.api.get(`/orders/production/${params.id}/file`, {
          params: {
            type: state.type,
            status: state.status,
          }
        })

        return {
          files: result.map(e => ({ url: e.url, filename: e.fileName }))
        }
      }}
      submitter={{
        searchConfig: {
          submitText: '关闭',
        },
        resetButtonProps: {
          style: {
            display: 'none',
          },
        },
      }}
      onFinish={async () => true}
      onOpenChange={e => Object.assign(state, { open: e })}
    >
      <UploadImage
        readonly
        max={10}
        name='files'
        label='查看图片'
        fieldProps={{ upload: handleUpload }}
        onSave={e => handleUploadSave.runAsync(e, state.status)}
      />
    </ModalForm>
  </div>
}
